module.exports = __webpack_public_path__ + "img/icon_04.3c099ecd.gif";